import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Linux = () => {
  return (
    <StartInterviewLayout type="linux"/>
  )
}

export default Linux;